import { useArticleSubscriptionRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetArticleSubscriptionCommonInfoQuery } from "../../features/articles/articleSubscriptionSlice";
import { SubscriptionCommonInfoModel } from "../../entities/subscription";
import { Descriptions } from "antd";

export { useArticleSubscriptionRoutes };

export default GetDefaultIndex({
  title: "اشتراک‌های مقالات",
  query: useGetArticleSubscriptionCommonInfoQuery,
  extra: null,
  generalInfoPresentor: (info: SubscriptionCommonInfoModel) =>
    info ? (
      <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 2, md: 2, sm: 1, xs: 1 }}>
        <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
          {info.totalRecords}
        </Descriptions.Item>
        <Descriptions.Item label="تعداد فعال" labelStyle={{ color: "gray" }}>
          {info.activeRecords}
        </Descriptions.Item>
      </Descriptions>
    ) : null,
});
